import { Content } from "../types";

export function markAnswer(content: Content): void {}
